<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-05-13 20:04:58
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-20 22:11:23
 * @FilePath: /goldenSalesMobile/src/views/RefundOrder/Detail/index.vue
 * @Description: 退款订单详情
-->
<template>
  <div class='page-container'>
    <div class="refund-info">
      <p><span>退款单号</span><span>{{ orderId }}</span></p>
      <p><span>创建时间</span><span>{{ creaTime }}</span></p>
      <p><span>退款金额</span><span class="refund-money">￥{{ refundAmount }}</span></p>
      <p><span>退回账户</span><span>微信支付账户</span></p>
      <p><span>到账时间</span><span>预计9个工作日内到账</span></p>
    </div>
    <div class="refund-goods">
      <ul>
        <li>
          <span>退款商品</span>
          <span>金额</span>
          <span>数量</span>
        </li>
        <li v-for="(item, index) in refundGoodsList" :key="index">
          <span>{{ item.ProductShelfName }}</span>
          <span>￥{{ item.Amount }}</span>
          <span>{{ item.Quantity }}</span>
        </li>
      </ul>
    </div>
    <div class="refund-steps">
      <p>退款流程</p>
      <van-steps direction="vertical" :active="stepIndex">
        <van-step>
          <h3>系统审核中</h3>
          <p>待系统审核通过后退款申请将提交微信</p>
        </van-step>
        <van-step>
          <block v-if="isRejective">
            <h3>系统审核未通过</h3>
            <h3>退款申请被商家拒绝，详情请咨询商家</h3>
          </block>
          <block v-else>
            <h3>系统审核通过</h3>
            <p>退款申请已提交微信</p>
          </block>
        </van-step>
        <van-step>
          <h3>微信受理退款成功</h3>
          <p>您的退款已被微信受理</p>
        </van-step>
        <van-step>
          <h3>微信入账中</h3>
          <p>退款将会入账至您的微信支付账户中，请您注意查收</p>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>
import { getRefundOrderDetail } from '@/api/refund'

export default {
  data() {
    return {
      orderId: this.$route.params.id,
      creaTime: '',
      refundAmount: 0,
      refundGoodsList: [],
      stepIndex: 0,
      isRejective: false
    }
  },

  created() {
    getRefundOrderDetail({
      query: {
        id: this.orderId
      }
    })
      .then(res => {
        let data = res.Items[0];
        if (data) {
          this.refundAmount = data.Amount
          this.creaTime = data.CreateTime
          if (data.Status.Id === 2) { // 退款申请通过&微信受理退款成功
            this.stepIndex = 2
          } else if (data.Status.Id === 3) { // 商家拒绝退款
            this.stepIndex = 1
            this.isRejective = true
          } else if (data.Status.Id === 4) { //微信退款入账
            this.stepIndex = 3
          }
          this.refundGoodsList = data.Details ? data.Details : []
        }
      })
      .catch(err => {
// console.log(`获取退单详情报错${err}`)
      })
  }
}
</script>

<style lang='scss' scoped>
  .page-container {
    .refund-info {
      @include border-box(20px 40px);
      background: $blockBgColor;
      border-bottom: 1px solid #eee;

      >p {
        line-height: 2;
        font-size: 28px;

        >span:first-child {
          margin-right: 100px;
          color: $secondFontColor;
        }

        >span:last-child:not(.refund-money) {
          color: $baseFontColor;
        }

        .refund-money {
          color: $priceFontColor;
        }
      }
    }

    .refund-goods {
      @include border-box(20px 40px);
      background: $blockBgColor;
      margin-bottom: 20px;

      li {
        @include flex-box(space-between);
        line-height: 2;
        font-size: 28px;

        &:first-child {
          color: $secondFontColor;
        }

        &:not(:first-child) {
          color: $baseFontColor;
        }

        >span:not(:first-child) {
          flex: 1;
          text-align: right;
        }

        >span:first-child {
          flex: 3;
          max-width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }

    .refund-steps {
      @include border-box(20px 40px);
      background: $blockBgColor;

      >p {
        line-height: 2;
        font-size: 30px;
        color: $secondFontColor;
        border-bottom: 1px solid #eee;
      }

      &::v-deep .van-step--vertical {
        line-height: 24px;
      }
    }
  }
</style>
